<div class="attachment-dialog">
  <button class="modal-close-btn" (click)="close()" aria-label="Close attachment preview">
    <mat-icon>close</mat-icon>
  </button>
  @if (attachmentType?.startsWith('image/') && imageDataUrl) {
  <div class="img-container">
    <img [src]="imageDataUrl" alt="Attachment Preview" />
  </div>
  } @if (attachmentType === 'application/pdf' && safeUrl) {
  <div class="pdf-container">
    <iframe [src]="safeUrl" style="min-height: 480px; width: 100%; border: none" title="PDF preview"></iframe>
  </div>
  }
</div>
